import React, {useState, useEffect} from 'react';
import {useHistory, useParams} from "react-router-dom";
import {withTranslation} from 'react-i18next';
import {ProgressBar} from 'primereact/progressbar';
import {Button} from "primereact/button";
import axios from "axios";

const OfferitemListComponent = (props) => {

  const {t} = props;
  const history = useHistory();
  const {id} = useParams();
  const [loading, setLoading] = useState(false);
  const [items, setItems] = useState([]);
  const [detailsVisibleBySchema, setDetailsVisibleBySchema] = useState({});
  const [offerCurrency, setOfferCurrency] = useState('HUF');

  const apiCall = (method, url, data) => {
    return axios({
      method: method,
      url: process.env.REACT_APP_API_HOST + url,
      data,
      params: {},
      headers: {
        'Authorization': 'Bearer ' + localStorage.getItem("userToken"),
        'App-Network': localStorage.getItem("networkId")
      }
    })
  }

  const formatCellValue = (value, fieldSchema) => {
    if (value === null || value === undefined || value === '') return '';
    if (fieldSchema?.output_format === 'currency') {
      return window.App.currencyFormatter(offerCurrency, value);
    }
    if ( fieldSchema?.type === 'bool') {
      const boolValue = value === true || value === 1;
      return boolValue ? (
        <i className="pi pi-check text-success" title={props.t('yes')}></i>
      ) : (
        <i className="pi pi-times text-danger" title={props.t('no')}></i>
      );
    }
    if (fieldSchema?.type === 'number') {
      return Number(value).toLocaleString('hu-HU', {
        minimumFractionDigits: 0,
        maximumFractionDigits: 3
      });
    }
    if (fieldSchema?.options?.labelField) {
      return value?.[fieldSchema.options.labelField] || value?.name || value;
    }
    return value?.name || value;
  };

  const renderSummaryRow = (schemaItem, fields, actionColumn = true) => {
    const summary = schemaItem?.summary?.projectItem || {};
    const summaryKeys = Object.keys(summary);
    if (!fields?.length || !summaryKeys.length) {
      return null;
    }
    const hasMatchingField = fields.some(field =>
      Object.prototype.hasOwnProperty.call(summary, field.name)
    );
    if (!hasMatchingField) {
      return null;
    }
    return (
      <tr className="offer-item-summary-row">
        {fields.map((field, index) => {
          const hasValue = Object.prototype.hasOwnProperty.call(summary, field.name);

          return (
            <td key={field.name || index} className="p-text-left">
              <strong>
                {index === 0
                  ? t('total')
                  : hasValue
                    ? formatCellValue(summary[field.name], field)
                    : ''}
              </strong>
            </td>
          );
        })}
        {actionColumn && <td></td>}
      </tr>
    );
  };

  const isDetailsVisible = (schemaItem, index) => {
    const key = schemaItem?.schema?.id || index;
    return detailsVisibleBySchema[key] !== false;
  };

  const toggleDetailsVisible = (schemaItem, index) => {
    const key = schemaItem?.schema?.id || index;
    setDetailsVisibleBySchema(prev => ({
      ...prev,
      [key]: prev[key] === false
    }));
  };

  const renderSchemaSummary = (schemaItem) => {
    const projectItemFields = schemaItem?.header?.projectItem?.fields || [];
    const productionItemFields = schemaItem?.header?.productionItems?.fields || [];
    const summary = schemaItem?.summary?.projectItem || {};
    const hasProjectItemSummary = projectItemFields.some(field =>
      Object.prototype.hasOwnProperty.call(summary, field.name)
    );
    if (hasProjectItemSummary) {
      return renderSummaryRow(schemaItem, projectItemFields, true);
    }
    const hasProductionItemSummary = productionItemFields.some(field =>
      Object.prototype.hasOwnProperty.call(summary, field.name)
    );
    if (hasProductionItemSummary) {
      return (
        <tr className="offer-item-summary-wrapper-row">
          <td
            colSpan={(projectItemFields.length || 0) + 1}
            className="p-text-center p-py-0 p-px-0"
          >
            <table className="w-100 offer-item-summary-table" cellPadding="5px" cellSpacing={0}>
              <tbody>
                {renderSummaryRow(schemaItem, productionItemFields, false)}
              </tbody>
            </table>
          </td>
        </tr>
      );
    }
    return null;
  };

  const deleteOfferItem = (offerItemId) => {
    if (!window.confirm('A törlés megerősítésére van szükség!')) {
      return;
    }
    apiCall('delete', '/api/v2/offer-item/' + offerItemId)
      .then(() => {
        window.App.toastShow('success', 'Sikeres törlés!');
        window.App.setState({
          rerenderOfferitemList: Math.random(),
          rerenderOfferShow: Math.random(),
          rerenderOfferList: Math.random()
        });
      })
      .catch(error => {
        window.App.toastShow('error', 'Hiba', error.toString(), '', error.response);
      });
  };

  // useEffect(() => {
  //   if (id && id !== 'undefined') {
  //     setLoading(true);
  //     apiCall('get', '/api/v2/offer-item/' + id + '/by-offer-and-schema')
  //       .then(response => {
  //         setItems(response?.data?.data || []);
  //       })
  //       .catch(error => {
  //         window.App.toastShow('error', t('error'), error.toString(), '', error.response);
  //       })
  //       .finally(() => setLoading(false));
  //   }
  // }, [id, window.App.state.rerenderOfferitemList]);

  useEffect(() => {
    if (id && id !== 'undefined') {
      setLoading(true);
      apiCall('get', '/api/v2/offer-item/' + id + '/by-offer-and-schema')
        .then(response => {
          setItems(response?.data?.data || []);
        })
        .catch(error => {
          window.App.toastShow('error', t('error'), error.toString(), '', error.response);
        })
        .finally(() => setLoading(false));
      apiCall('get', '/api/v2/offer/' + id)
        .then(response => {
          const data = response?.data?.data || {};
          const currency = data?.currency || 'HUF';
          setOfferCurrency(currency);
        })
        .catch(() => {
          setOfferCurrency('HUF');
        });
    }
  }, [id, window.App.state.rerenderOfferitemList, window.App.state.rerenderOfferShow, window.App.state.rerenderOfferList]);

  return (
    <div className={"offer-form widget"}>
      {loading &&
        <ProgressBar mode="indeterminate"
          style={{height: '5px', position: "absolute", top: 0, left: 0, borderRadius: 0,}} />
      }

      {items.map((schemaItem, index) => {
        let _classes = 'p-m-0 p-p-0'
        if (index > 0) {
          _classes = 'p-mb-0 p-p-0 p-mt-3'
        }
        const detailsVisible = isDetailsVisible(schemaItem, index);

        return (
          <React.Fragment key={schemaItem?.schema?.id || index}>
            <div className={"p-grid"}>
              <div className={"p-col-12 p-lg-6 p-xl-6"}>
                <h3 className={" " + _classes}>
                  {schemaItem?.schema?.name || t('items')}
                  <Button
                    type="button"
                    icon={detailsVisible ? "pi pi-eye-slash" : "pi pi-eye"}
                    className="item-eye-toggle p-button-text p-button-sm p-ml-2"
                    tooltip={detailsVisible ? t('hideDetails') : t('showDetails')}
                    tooltipOptions={{ position: 'right' }}
                    onClick={() => toggleDetailsVisible(schemaItem, index)}
                    style={{
                      width: '1.8rem',
                      height: '1.8rem',
                      verticalAlign: 'middle'
                    }}
                  />
                </h3>
              </div>
              <div className={"p-col-12 p-lg-6 p-xl-6 p-text-right p-col-align-center"} />
            </div>

            <table className={"p-mt-0 w-100"} cellPadding={'5px'} cellSpacing={0}>
              <tr>
                {schemaItem?.header?.projectItem?.fields?.map((field) => {
                  return (
                    <th
                      key={field.name}
                      className={"p-text-left"}
                      style={{ fontWeight: 'normal' }}
                    >
                      {field.label}
                    </th>
                  )
                })}
                <th></th>
              </tr>

              {(schemaItem?.items || []).map((item, rowIndex) => {
                return (
                  <React.Fragment key={item?.id || rowIndex}>
                    <tr>
                      {schemaItem?.header?.projectItem?.fields?.map((field, fieldIndex) => {
                        return (
                          <td key={field.name || fieldIndex} className={field.name === 'name' ? 'offer-item-name-cell' : ''}>
                            {formatCellValue(item.projectItem?.[field.name], field)}
                          </td>
                        );
                      })}
                      <td className={"p-text-right"}>
                        <Button icon="pi pi-pencil" className="p-button-sm p-button-warning p-ml-2"
                          tooltip={t('edit')}
                          type={"button"}
                          loading={loading}
                          tooltipOptions={{position: 'left'}}
                          onClick={() => {
                            history.push(
                              '/project/offer/read/' + id +
                              '?update=offerItem' +
                              '&offerItemSchemaId=' + (schemaItem?.schema?.id || '') +
                              '&offerItemId=' + item.id
                            )
                          }}
                        />
                        {(localStorage.getItem('roles') || '[]').includes('role_offer_write') && (
                          <Button
                            icon="pi pi-trash"
                            className="p-button-sm p-button-danger p-ml-2"
                            tooltip={t('delete')}
                            type="button"
                            loading={loading}
                            tooltipOptions={{position: 'left'}}
                            onClick={() => deleteOfferItem(item.id)}
                          />
                        )}
                      </td>
                    </tr>

                    {detailsVisible && item.production_items && item.production_items[0] &&
                      <tr>
                        <td colSpan={(schemaItem?.header?.projectItem?.fields?.length || 0) + 1} className={"p-text-center p-py-0 p-px-0"}>
                          <table className={"w-100"} cellPadding={'1px'} cellSpacing={0}>
                            <tr>
                              {schemaItem?.header?.productionItems?.fields?.map((field) => {
                                return (
                                  <th key={field.name} className={"p-text-left p-pl-1"} style={{ fontWeight: 'normal' }}>
                                    <small>{field.label}</small>
                                  </th>
                                )
                              })}
                            </tr>
                            {item.production_items
                            .filter(productionItem => productionItem?.id !== null)
                            .map((productionItem, pi) => {
                              return (
                                <tr key={productionItem?.id || pi}>
                                  {schemaItem?.header?.productionItems?.fields?.map((field) => {
                                    const value = productionItem[field.name];
                                    return (
                                      <td key={field.name} className={"p-text-left p-pl-1"}>
                                        <small>
                                          {formatCellValue(value, field)}
                                        </small>
                                      </td>
                                    )
                                  })}
                                </tr>
                              )
                            })}
                          </table>
                        </td>
                      </tr>
                    }

                    {detailsVisible && item.materials && item.materials[0] &&
                      <tr>
                        <td colSpan={(schemaItem?.header?.projectItem?.fields?.length || 0) + 1} className={"p-text-center p-py-0 p-px-0"}>
                          <table className={"w-100"} cellPadding={'1px'} cellSpacing={0}>
                            <tr>
                              {schemaItem?.header?.materials?.fields?.map((field) => {
                                return (
                                  <th
                                    key={field.name}
                                    className={"p-text-left p-pl-1"}
                                    style={{ fontWeight: 'normal' }}
                                  >
                                    <small>{field.label}</small>
                                  </th>
                                )
                              })}                              
                            </tr>
                            {item.materials.map((materialItem, mi) => {
                              return (
                                <tr key={materialItem?.id || mi}>
                                  {schemaItem?.header?.materials?.fields?.map((field) => {
                                    let value = materialItem?.[field.name];
                                    if (value === undefined) {
                                      if (field.name === 'dimension_x') value = materialItem?.dimensionX;
                                      if (field.name === 'dimension_y') value = materialItem?.dimensionY;
                                      if (field.name === 'dimension_z') value = materialItem?.dimensionZ;
                                    }
                                    return (
                                      <td key={field.name} className={"p-text-left p-pl-1"}>
                                        <small>{formatCellValue(value, field)}</small>
                                      </td>
                                    );
                                  })}
                                </tr>
                              )
                            })}
                          </table>
                        </td>
                      </tr>
                    }
                  </React.Fragment>
                )
              })}
              {renderSchemaSummary(schemaItem)}
            </table>
          </React.Fragment>
        )
      })}
    </div>
  )
}

export default withTranslation('common')(OfferitemListComponent);
